import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=83f38bcc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83f38bcc')) {
      api.createRecord('83f38bcc', component.options)
    } else {
      api.reload('83f38bcc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=83f38bcc&", function () {
      api.rerender('83f38bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EpLz0ySriD1z/JS/offershelp.vue"
export default component.exports